import { CRAFTING_RECIPES } from './recipes';
import {
  addInventoryItem,
  playerState,
  refreshHud,
  spendDust,
} from '../player-state';
import { isBackendEnabled, queueSync } from '../../net/backend';

const DEFAULT_WEAPON = 'WoodClub';

function isDefaultWoodClub(slot: { name: string; isDefault?: boolean } | null) {
  return Boolean(slot?.isDefault && slot.name === DEFAULT_WEAPON);
}

export function matchForgeRecipe() {
  const { craftingIngredients } = playerState;
  const ing1 = craftingIngredients[1];
  const ing2 = craftingIngredients[2];
  if (!ing1 || !ing2) return null;
  return CRAFTING_RECIPES.find((r) => r.ing1 === ing1 && r.ing2 === ing2) ?? null;
}

export function getForgeUiState() {
  const recipe = matchForgeRecipe();
  const resultPreview = playerState.forgedResult || recipe?.result || null;
  const cost = recipe && !playerState.forgedResult ? (recipe.dustCost ?? 0) : 0;
  const canForge = Boolean(recipe && !playerState.forgedResult && playerState.dust >= cost);
  return {
    ingredients: { ...playerState.craftingIngredients },
    forgedResult: playerState.forgedResult,
    resultPreview,
    recipe,
    dustCost: cost,
    canForge,
    canClaim: Boolean(playerState.forgedResult),
  };
}


export function fillIngredientFromInventory(slotIndex: number) {
  if (playerState.forgedResult) return false;
  const slotData = playerState.inventorySlots[slotIndex];
  if (!slotData?.count) return false;

  let target: 1 | 2 | null = null;
  if (!playerState.craftingIngredients[1]) target = 1;
  else if (!playerState.craftingIngredients[2]) target = 2;
  else return false;

  playerState.craftingIngredients[target] = slotData.name;
  if (isDefaultWoodClub(slotData)) return true;
  if (slotData.count > 1) slotData.count -= 1;
  else playerState.inventorySlots[slotIndex] = null;
  return true;
}

export function clearForgeIngredientSlot(slotNum: 1 | 2) {
  const item = playerState.craftingIngredients[slotNum];
  if (!item) return false;
  playerState.craftingIngredients[slotNum] = null;
  addInventoryItem(item, 1);
  return true;
}

export function runForge() {
  const recipe = matchForgeRecipe();
  if (!recipe || playerState.forgedResult) return false;
  const cost = recipe.dustCost ?? 0;
  if (playerState.dust < cost) return false;
  if (cost > 0) spendDust(cost);
  playerState.forgedResult = recipe.result;
  playerState.craftingIngredients = { 1: null, 2: null };
  refreshHud();
  if (isBackendEnabled()) queueSync('full');
  return true;
}

export function claimForgeResult() {
  if (!playerState.forgedResult) return false;
  const item = playerState.forgedResult;
  playerState.forgedResult = null;

  const recipe = CRAFTING_RECIPES.find((r) => r.result === item);
  const isArmor = recipe?.isArmor ?? false;
  const isWeapon = recipe ? recipe.isWeapon !== false && !isArmor : false;

  if (isWeapon) {
    playerState.equipped.weapon = item;
  } else if (isArmor) {
    if (item.includes('Shoulderpads')) playerState.equipped.head = item;
    else playerState.equipped.body = item;
  } else {
    addInventoryItem(item, 1);
  }

  refreshHud();
  if (isBackendEnabled()) queueSync('full');
  return true;
}

export function returnIngredientsToInventory() {
  for (const slotNum of [1, 2] as const) {
    const item = playerState.craftingIngredients[slotNum];
    if (!item) continue;
    playerState.craftingIngredients[slotNum] = null;
    addInventoryItem(item, 1);
  }
}
